// extracted by mini-css-extract-plugin
module.exports = {"w1r1ae0j":"w1r1ae0j"};